import { h } from 'preact';

function ErrorIcon ({ color, height = 0, width = 0, size = 30 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
      fill="#fff"
      height={height || size}
      width={width || size}
    >
      <path
        d="M15 3a2 2 0 00-1.846 1.229L2.301 22.947v.002A2 2 0 002 24a2 2 0 002 2 2 2 0 00.14-.006l.005.006h21.71l.004-.008A2 2 0 0026 26a2 2 0 002-2 2 2 0 00-.3-1.053l-.016-.027a2 2 0 00-.002-.002L16.846 4.228A2 2 0 0015 3zm-1.213 8.36h2.426l-.201 6.472h-2.024l-.2-6.473zm1.217 8.45c.822 0 1.314.443 1.314 1.198 0 .74-.492 1.181-1.314 1.181-.828 0-1.324-.44-1.324-1.181 0-.755.495-1.197 1.324-1.197z"
        fill={color || '#c71514'}
      />
    </svg>
  );
}

export default ErrorIcon;
